import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router, Event, NavigationEnd } from '@angular/router';
import { SessionService } from '../../services/session/session.service';
import { TemplatesService } from '../../services/templates/templates.service';
import { ToastUiImageEditorComponent } from 'ngx-tui-image-editor';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import * as WebFont from 'webfontloader';

@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss'],
})
export class ImageEditorComponent implements OnInit, AfterViewInit {
  private jsonInstance = '';
  @ViewChild(ToastUiImageEditorComponent)
  editorComponent: ToastUiImageEditorComponent;
  public tuiInsatance: any; //Tui editor instance
  public fabricInstance: any; // Canvas library used by Tui
  public userLogged;

  public editorobject = {
    includeUI: {
      menuBarPosition: 'bottom',
      loadImage: {
        path: '/assets/images/background.jpg',
        name: 'myimage name',
      },
      menu: [
        'crop',
        'flip',
        'rotate',
        'draw',
        'shape',
        'icon',
        'text',
        'filter',
        'mask',
      ],
      uiSize: { width: '100%', height: '600px' },
    },
    cssMaxWidth: 800,
    cssMaxHeight: 350,
    selectionStyle: {
      cornerSize: 20,
      rotatingPointOffset: 70,
    },
  };
  public showMenu: any = false;
  public showSideMenu: any = true;
  public templateLoaded: any;
  public allTemplatesType: any;
  public selectedType;
  public isAdmin: boolean;
  public imageId: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private SessionService: SessionService,
    private TemplatesService: TemplatesService,
    private el: ElementRef,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {this.userLogged = this.SessionService.loggedInUser();
    this.imageId = this.route.snapshot.paramMap.get('id');
    this.isAdmin = this.SessionService.isAdmin();
    // var image = this.route.snapshot.paramMap.get('image');
    // if(image)this.editorobject.includeUI.loadImage.path = 'assets/images/'+image;
    this.getAllTypeAndTemplate();
  }

  ngAfterViewInit() {
    this.tuiInsatance = this.editorComponent.editorInstance;
    this.fabricInstance = this.tuiInsatance._graphics.getCanvas();

    if (this.isAdmin) this.appendCustomOptions();
    this.appendLayerOptions();
    if (this.imageId) {
      this.SpinnerService.show();
      WebFont.load({
        custom: {
          families: [
            'Passion One',
            'Noto Sans',
            'Pacifico',
            'Open Sans',
            'Merriweather',
            'Droid Sans',
            'Diplomata',
            'Gravitas One',
            'Fascinate',
            'Roboto',
            'Lato',
          ],
          urls: ['/styles.scss']
        },
        active: () => {
          console.log('Font loaded');
          this.TemplatesService.getTemplates({ id: this.imageId }).then(
            (result) => {
              var data = result['data'][0];
              this.templateLoaded = data;
              this.selectedType = this.templateLoaded.typeId;
              var json = JSON.parse(data.dataText);
              this.tuiInsatance.loadImageFromURL(json.backgroundImage.src, 'lena').then(result => {
                this.fabricInstance.loadFromJSON(
                  json,
                  ()=>{
                      this.fabricInstance.renderAll.bind(this.fabricInstance);
                      this.SpinnerService.hide();
                      console.log('template loaded');
                  },
                  function (o, obj) {
                    if (obj.type === 'i-text') {
                      obj.jsonLoad = true;
                    }
                  }
                );
              });
            }
          );
        },
        inactive:function(){
          console.log('unable to load fonts');
        }
      })

    }
  }

  getAllTypeAndTemplate() {
    this.TemplatesService.getAllTypeAndTemplate({
      imageEditor: true,
    }).then((result) => {
      var data = result['data'];
      // console.log(result);
      this.allTemplatesType = data.types;
    });
  }

  getTemplateData(id) {
    this.SpinnerService.show();
    this.TemplatesService.getTemplates({ id: id }).then((result) => {
      var data = result['data'];
      this.templateLoaded = data[0];
      this.selectedType = this.templateLoaded.typeId;
      this.SpinnerService.hide();
    });
  }

  showMenuFn() {
    this.showMenu = !this.showMenu;
  }

  showSideMenuFn() {
    this.showSideMenu = !this.showSideMenu;
  }

  Logout() {
    this.SessionService.logout();
    this.router.navigate(['/']);
  }

  appendLayerOptions(){
    $('.tui-image-editor-menu').prepend(
      '<li tooltip-content="" style="position: relative;top: 10px;" class="tie-btn-undo tui-image-editor-item" id="bringForward"><i class="fas fa-angle-up" style="font-size:30px;color:#8a8a8a"></i></li><li tooltip-content="" style="position: relative;top: 10px;" class="tie-btn-undo tui-image-editor-item" id="sendBackward"><i style="font-size:30px;color:#8a8a8a" class="fas fa-angle-down"></i></li><li tooltip-content="" style="position: relative;top: 5px;" class="tie-btn-undo tui-image-editor-item" id="addText"><i class="fas fa-text-width" style="font-size:20px;color:#8a8a8a"></i></li>'
    );

    this.el.nativeElement
      .querySelector('.tui-image-editor-menu #bringForward')
      .addEventListener('click', this.bringForward.bind(this));

    this.el.nativeElement
      .querySelector('.tui-image-editor-menu #sendBackward')
      .addEventListener('click', this.sendToBack.bind(this));

      this.el.nativeElement
      .querySelector('.tui-image-editor-menu #addText')
      .addEventListener('click', this.addText.bind(this));
  }

  appendCustomOptions() {
    if (this.imageId)
      $('.tui-image-editor-header-buttons').append(
        "<button class='btn btn-primary border-0' id='saveTemplate' >Update</button>"
      );
    else{
      $('.tui-image-editor-header-buttons').append(
        "<button class='btn btn-primary border-0' id='saveTemplate' >Save</button>"
      );
    }

    this.el.nativeElement
      .querySelector('.tui-image-editor-header-buttons #saveTemplate')
      .addEventListener('click', this.save.bind(this));
  }

  save() {
    if (this.selectedType == 0 || !this.selectedType) {
      this.toastr.error('type not seleced');
      return;
    }
    var self = this;
    this.SpinnerService.show();
    // console.log('here');
    // console.log(this.tuiInsatance.toDataURL());
    var img = this.tuiInsatance.toDataURL();
    setTimeout(function () {
      self.upload(img);
    }, 100);
  }

  upload(image) {
    var self = this;
    var name = 'name';
    let imagetoSave = {
      id: this.templateLoaded ? this.templateLoaded.id : null,
      title: this.templateLoaded ? this.templateLoaded.title : name,
      typeId: self.selectedType,
      image: image,
      dataText: JSON.stringify(this.fabricInstance),
      format: 'png', //file['type']=='image/jpeg'?'jpg':'png'
    };
    if (this.templateLoaded) {
      self.TemplatesService.updateTemplates(imagetoSave).then((result) => {
        this.toastr.success('Changes saved');
        // self.tuiInsatance.clearObjects();
        this.SpinnerService.hide();
      });
    } else {
      self.TemplatesService.addNewTemplates(imagetoSave).then((result) => {
        this.toastr.success('Image saved');
        // self.tuiInsatance.clearObjects();
        this.SpinnerService.hide();
      });
    }
  }

  sendToBack(){
    let obj = this.fabricInstance.getActiveObject();
    // console.log(obj);
    // this.fabricInstance.sendToBack(obj);
    this.fabricInstance.sendBackwards(obj);
  }

  addText(){
    this.tuiInsatance.addText('Double Click',{
      styles: {
        fill: '#fff',
        fontSize: 80
      }
    }).then((obj)=>{
        console.log(obj);
    });
  }

  bringForward(){
    let obj = this.fabricInstance.getActiveObject();
    //  obj.sendBackwards();
    this.fabricInstance.bringForward(obj);
  }

  backgroundColor(){
    this.fabricInstance.backgroundImage = 0;
    this.fabricInstance.backgroundColor="#FFFFFF";
    this.fabricInstance.renderAll();
  }
}
